import React from "react";
import { makeStyles } from "@material-ui/core";

// Import base and hover images
import img1 from "../../../assets/Images/PickaaGo Product/1.png";
import img1a from "../../../assets/Images/PickaaGo Product/1a.png";
import img2 from "../../../assets/Images/PickaaGo Product/2.png";
import img2a from "../../../assets/Images/PickaaGo Product/2a.png";
import img3 from "../../../assets/Images/PickaaGo Product/3.png";
import img3a from "../../../assets/Images/PickaaGo Product/3a.png";

const useStyles = makeStyles({
  root: {
    width: "90%",
    margin: "0 100px",
    display: "flex",
    flexDirection: "column",
    padding: "20px 0",
  },
  heading: {
    fontSize: "36px",
    fontWeight: "600",
    textAlign: "center",
    marginBottom: "40px",
     fontFamily: "Poppins",  

  },
  imageRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    flexWrap: "wrap",
  },
  imageWrapper: {
    position: "relative",
    width: "30%",
    cursor: "pointer",
    "& img": {
      width: "80%",
      borderRadius: "12px",
      transition: "opacity 0.3s ease-in-out",
    },
  },
  hoverImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "60%",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
    borderRadius: "12px",
    "&:hover": {
      opacity: 1,
    },
  },
  baseImage: {
    display: "block",
    borderRadius: "12px",
  },
});

const Product = () => {
  const classes = useStyles();

  const imagePairs = [
    { base: img1, hover: img1a },
    { base: img2, hover: img2a },
    { base: img3, hover: img3a },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.heading}>Products</div>
      <div className={classes.imageRow}>
        {imagePairs.map((img, index) => (
          <div className={classes.imageWrapper} key={index}>
            <img src={img.base} alt={`Product ${index + 1}`} className={classes.baseImage} />
            <img src={img.hover} alt={`Product ${index + 1} Hover`} className={classes.hoverImage} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Product;